const CrossIcon = ({ className = "" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0005 13.0543L6.9275 18.1275C6.789 18.2658 6.61492 18.3367 6.40525 18.34C6.19575 18.3432 6.0185 18.2723 5.8735 18.1275C5.72867 17.9825 5.65625 17.8068 5.65625 17.6005C5.65625 17.3942 5.72867 17.2185 5.8735 17.0735L10.9468 12.0005L5.8735 6.9275C5.73517 6.789 5.66433 6.61492 5.661 6.40525C5.65783 6.19575 5.72867 6.0185 5.8735 5.8735C6.0185 5.72867 6.19417 5.65625 6.4005 5.65625C6.60683 5.65625 6.7825 5.72867 6.9275 5.8735L12.0005 10.9468L17.0735 5.8735C17.212 5.73517 17.3861 5.66433 17.5958 5.661C17.8053 5.65783 17.9825 5.72867 18.1275 5.8735C18.2723 6.0185 18.3448 6.19417 18.3448 6.4005C18.3448 6.60683 18.2723 6.7825 18.1275 6.9275L13.0543 12.0005L18.1275 17.0735C18.2658 17.212 18.3367 17.3861 18.34 17.5958C18.3432 17.8053 18.2723 17.9825 18.1275 18.1275C17.9825 18.2723 17.8068 18.3448 17.6005 18.3448C17.3942 18.3448 17.2185 18.2723 17.0735 18.1275L12.0005 13.0543Z"
      fill="#525252"
    />
  </svg>
);
export default CrossIcon; 
